import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail, Send, TrendingUp, Shield, AlertTriangle } from 'lucide-react';

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    // Mock subscription
    alert('Thank you for subscribing!');
  };

  return (
    <footer className="bg-secondary text-secondary-foreground">
      {/* Disclaimer Section */}
      <div className="border-b border-secondary-foreground/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-start gap-4 p-4 rounded-lg bg-secondary-foreground/5">
            <AlertTriangle className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              <p className="font-semibold mb-1">Important Disclaimer</p>
              <p className="text-secondary-foreground/80 leading-relaxed">
                Market news is for informational purposes only. This is not investment advice. 
                Content is automatically aggregated and AI-assisted summarized from publicly available 
                news feeds. Sources are credited. Always do your own research before making investment decisions.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                <TrendingUp className="w-6 h-6 text-primary-foreground" />
              </div>
              <span className="text-xl font-bold">Trade<span className="text-primary">Pulse</span></span>
            </div>
            <p className="text-secondary-foreground/70 text-sm mb-6 leading-relaxed">
              Your trusted source for real-time trading and stock market news with AI-assisted 
              summaries covering global markets.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', href: '#home' },
                { name: 'Latest News', href: '#news' },
                { name: 'Market Analysis', href: '#features' },
                { name: 'Trading Tips', href: '#features' },
                { name: 'About Us', href: '#about' },
                { name: 'Contact', href: '#contact' }
              ].map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary/50"></span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Markets We Cover */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Markets We Cover</h4>
            <ul className="space-y-3">
              {[
                { name: 'NSE / BSE India', flag: '🇮🇳', href: 'https://www.nseindia.com/' },
                { name: 'NYSE / NASDAQ', flag: '🇺🇸', href: 'https://www.nyse.com/' },
                { name: 'London Stock Exchange', flag: '🇬🇧', href: 'https://www.londonstockexchange.com/' },
                { name: 'Forex Markets', flag: '💱', href: 'https://www.forexfactory.com/' },
                { name: 'Cryptocurrency', flag: '₿', href: 'https://coinmarketcap.com/' },
                { name: 'Commodities', flag: '🛢️', href: 'https://www.investing.com/commodities/' },
              ].map((market) => (
                <li key={market.name}>
                  <a href={market.href} target="_blank" rel="noopener noreferrer" className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors flex items-center gap-2">
                    <span>{market.flag}</span>
                    {market.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Stay Updated</h4>
            <p className="text-sm text-secondary-foreground/70 mb-4">
              Subscribe to our newsletter for daily market insights.
            </p>
            <form onSubmit={handleSubscribe} className="space-y-3">
              <Input 
                type="email" 
                placeholder="Enter your email"
                className="bg-secondary-foreground/10 border-secondary-foreground/20 text-secondary-foreground placeholder:text-secondary-foreground/50"
              />
              <Button type="submit" className="w-full btn-primary">
                <Send className="w-4 h-4 mr-2" />
                Subscribe
              </Button>
            </form>
            <div className="mt-6 space-y-2">
              <div className="flex items-center gap-2 text-sm text-secondary-foreground/70">
                <Mail className="w-4 h-4" />
                <span>jodexvfx@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-secondary-foreground/10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-secondary-foreground/60">
              © {new Date().getFullYear()} TradePulse. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-secondary-foreground/60">
              <Shield className="w-4 h-4" />
              <span>SEBI Compliance | Data Protection</span>
            </div>
            <div className="flex gap-4 text-sm">
              <a href="#" className="text-secondary-foreground/60 hover:text-primary transition-colors">Privacy Policy</a>
              <a href="#" className="text-secondary-foreground/60 hover:text-primary transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
